__turbopack_context__.v({
  "donorcount": "z9GwRa_donorcount",
  "lastupdated": "z9GwRa_lastupdated",
  "outputs": "z9GwRa_outputs",
  "subheader": "z9GwRa_subheader",
  "wrapper": "z9GwRa_wrapper",
});
